import * as React from 'react';
import * as url from 'url';
import AppConfig from '../AppConfig';
import Image from '../Image';
// Extract id if image in the same imageHost, else return it source
function tryExtractImageId({ src: _src, imageHost: _imageHost, }) {
    if (!_imageHost) {
        return _src;
    }
    const src = _src.replace(/^\/\//, 'http://');
    const imageHost = _imageHost.replace(/^\/\//, 'http://');
    const tmp = url.parse(src);
    if (tmp.hostname === url.parse(imageHost).hostname) {
        return tmp.pathname || '';
    }
    return src;
}
export default function MarkdownImage({ src: _src, title, alt, }) {
    return (React.createElement(AppConfig, null, ({ imageHost }) => {
        const src = tryExtractImageId({ src: _src, imageHost });
        const image = src.startsWith('//') || src.startsWith('http') ? (React.createElement(Image, { className: "w-100", src: src, title: title, alt: alt, usePlaceholder: true })) : (React.createElement(Image, { className: "w-100", id: src, title: title, alt: alt, usePlaceholder: true, thumbTransform: "w_80", transform: "w_800" }));
        return (React.createElement("figure", { className: "ma2" },
            image,
            React.createElement("figcaption", { className: "db ph2 pv1 tc i f6" }, title || alt)));
    }));
}
//# sourceMappingURL=Image.js.map